import {Component, computed, input, model} from '@angular/core';
import {NgTemplateOutlet} from '@angular/common';
import {Select} from 'primeng/select';
import {Button} from 'primeng/button';
import {InputGroup} from 'primeng/inputgroup';
import {TooltipModule} from 'primeng/tooltip';
import {FormsModule} from '@angular/forms';
import {TranslocoPipe} from '@jsverse/transloco';

export interface DropdownFilterOption<T = string> {
  label: string;
  value: T;
}

export type DropdownFilterDirection = 'ASC' | 'DESC';

@Component({
  selector: 'app-dropdown-filter',
  templateUrl: './dropdown-filter.component.html',
  styleUrl: './dropdown-filter.component.scss',
  imports: [
    NgTemplateOutlet,
    Select,
    Button,
    InputGroup,
    TooltipModule,
    FormsModule,
    TranslocoPipe,
  ],
})
export class DropdownFilterComponent<T = string> {
  readonly options = input.required<DropdownFilterOption<T>[]>();
  readonly value = model.required<T>();
  readonly styleClass = input<string>('min-w-48');
  readonly showDirection = input<boolean>(false);
  readonly direction = model<DropdownFilterDirection>('ASC');

  protected readonly directionIcon = computed<string>(() =>
    this.direction() === 'ASC' ? 'pi pi-sort-amount-up-alt' : 'pi pi-sort-amount-down',
  );

  protected toggleDirection(): void {
    this.direction.update((direction: DropdownFilterDirection) =>
      direction === 'ASC' ? 'DESC' : 'ASC',
    );
  }
}
